import style from './index.module.scss'
import NotFoundImg from '@/assets/images/404.png'
import NotFoundImgEn from '@/assets/images/404-en.png'
// 根据当前语言获取当前暂无数据的图片
const GETNODATAIMG = () => {
  const lang = localStorage.getItem('lang') || 'zh-CN'
  switch (lang) {
    case 'zh-CN':
      return NotFoundImg
    case 'en-US':
      return NotFoundImgEn
    default:
      return NotFoundImg
  }
}
export default () => {
  return (
    <div className={style.notFound} >
      <img src={GETNODATAIMG()} className={style.notFoundImg} alt="404"/>
    </div>
  )
}
